var map = {
	"./en.json": [
		790,
		790
	],
	"./es.json": [
		563,
		563
	],
	"./fr.json": [
		844,
		844
	],
	"./it.json": [
		504,
		504
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 404;
module.exports = webpackAsyncContext;